import { jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import React from 'react';
export const DiffPercentage = ({ diff, higherBetter = false }) => {
    const isPositive = higherBetter ? diff > 0 : diff < 0;
    const className = clsx('metric__diff', {
        'metric__diff--positive': isPositive,
        'metric__diff--negative': !isPositive,
        'metric__diff--up': diff > 0,
        'metric__diff--down': diff < 0,
    });
    return _jsxs("span", { className: className, children: [Math.abs(diff), "%"] });
};
